var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChargers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2023_4110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2.75L-0.25 21.25H3L21.5 2.75H18.25Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66896 20.9953C4.6957 20.9974 4.72273 20.9985 4.75 20.9985H12.75C13.3 20.9985 13.75 20.5485 13.75 19.9985V13.4985H15.25V18.3585C15.25 19.6685 16.19 20.8585 17.49 20.9885C18.99 21.1385 20.25 19.9685 20.25 18.4985V8.99854C20.25 8.30854 19.97 7.67853 19.52 7.22854L19.53 7.21853L18.9878 6.67638L17.6618 8.00242C17.6909 7.99985 17.7203 7.99854 17.75 7.99854C18.3 7.99854 18.75 8.44853 18.75 8.99854C18.75 9.54854 18.3 9.99854 17.75 9.99854C17.2 9.99854 16.75 9.54854 16.75 8.99854C16.75 8.96882 16.7513 8.93941 16.7539 8.91033L15.527 10.1372C15.9077 10.8666 16.6481 11.3978 17.48 11.4885C17.95 11.5385 18.36 11.4585 18.75 11.2885V18.4985C18.75 19.0485 18.3 19.4985 17.75 19.4985C17.2 19.4985 16.75 19.0485 16.75 18.4985V13.9985C16.75 12.8985 15.85 11.9985 14.75 11.9985H13.75V11.9142L4.66896 20.9953ZM15.7739 3.81189C15.5936 3.82038 15.4159 3.8926 15.28 4.02854C15.1441 4.16447 15.0718 4.34215 15.0633 4.52244L15.7739 3.81189ZM13.75 5.83579V4.99854C13.75 3.89854 12.85 2.99854 11.75 2.99854H5.75C4.65 2.99854 3.75 3.89854 3.75 4.99854V15.8358L6.22905 13.3567C6.0797 13.2099 6.02681 12.9723 6.14 12.7585L8.81 7.75853C9.05 7.30853 9.75 7.47853 9.75 7.99853V9.83579L13.75 5.83579ZM10.0015 10.9985L13.75 7.25V8.25L10.9914 11.0086C10.9589 11.002 10.9251 10.9985 10.89 10.9985H10.0015ZM7.50147 13.4985L3.75 17.25V18.25L7.75 14.25V13.4985H7.50147ZM16.6557 4.34427L17.1557 4.84427L16.0957 5.90427L15.5957 5.40427L16.6557 4.34427Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2023_4110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChargers);
export default __webpack_public_path__ + "static/media/NoChargers.c97411c9a8644cc61d410f0762776197.svg";
export { ForwardRef as ReactComponent };